import React, { useState, useEffect } from 'react';
import { Box, Collapse, IconButton, InputAdornment, List, ListItem, TextField, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { NoRecord } from '../../../CommonComponent/NoRecord';
import NoDataImg from '../../../../../images/my-goal-bg.svg';
import { AddIconSvg, DeleteIcon, EditIcon, RightArrowIcon } from '../../../../../config/svg/CommonSvgIcon';
import { OKRButton } from '../../../../Common/OKRButton';
import {
	addLevelsData,
	deleteLevelsData,
	frameworkList,
	getLevelsByParentAndLevel,
	skillListDataApi,
} from '../../../../../action/adminSettings';
import { useDispatch } from 'react-redux';

export const SkillList: React.FC<any> = (props: any) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const [skillListData, setSkillListData] = useState<any>(null);

	// State to manage the expanded section (only one at a time)
	const [expandCategory, setExpandCategory] = useState<number[]>([1, 5]);

	useEffect(() => {
		getSkillkList();
	}, []);

	const getSkillkList = async () => {
		try {
			const response: any = await dispatch(
				skillListDataApi({
					level: 0,
					pageIndex: 1,
					pageSize: 10,
				})
			);
			if (response) {
				if (response && response.data && response.data.status === 200) {
					setSkillListData(response.data.entityList || []);
				}
			}
		} catch (e) {
			console.error(e);
		}
	};
	// Toggle function for expanding/collapsing sections

	return (
		<>
			{skillListData && skillListData.length > 0 ? (
				<Box className='skills-listing-area'>
					<Box className='okr-list-panel-head'>
						<List component='ul'>
							<ListItem className='skill-col1'>
								<Typography variant='body2' className='sort-title'>
									<span className='sortable-label'>
										<span className='txt-wrap'>{t('Skill Code')}</span>
									</span>
								</Typography>
							</ListItem>
							<ListItem className='skill-col2'>
								<Typography variant='body2' className='sort-title'>
									<span className='sortable-label'>
										<span className='txt-wrap'>{t('Skill Name')}</span>
									</span>
								</Typography>
							</ListItem>
							<ListItem className='skill-col3'>
								<Typography variant='body2' className='sort-title'>
									<span className='sortable-label'>
										<span className='txt-wrap'> {`Mapped ${skillListData[0]?.lastLevelName}`}</span>
									</span>
								</Typography>
							</ListItem>
							<ListItem className='skill-col4'>
								<Typography variant='body2' className='sort-title'>
									<span className='sortable-label'>
										<span className='txt-wrap'>{t('In Demand')}</span>
									</span>
								</Typography>
							</ListItem>
							<ListItem className='skill-col5'>
								<Typography variant='body2' className='sort-title'>
									<span className='sortable-label'>
										<span className='txt-wrap'>{t('Status')}</span>
									</span>
								</Typography>
							</ListItem>
							<ListItem className='skill-col6'>
								<Typography variant='body2' className='sort-title'>
									<span className='sortable-label'>
										<span className='txt-wrap'>{t('# of Roles')}</span>
									</span>
								</Typography>
							</ListItem>
						</List>
					</Box>
					{skillListData.map((item: any) => (
						<Box className='skills-listing-content' key={item.skillId}>
							<List component='ul' disablePadding>
								<ListItem className='skill-col1'>
									<Typography>{item.skillCode}</Typography>
								</ListItem>
								<ListItem className='skill-col2'>
									<Typography>{item.name}</Typography>
									<Box className='skill-listing-actions'>
										<OKRButton icon={<EditIcon />} title={t('editLabel')} />
										<OKRButton icon={<DeleteIcon />} title={t('delete')} />
									</Box>
								</ListItem>
								<ListItem className='skill-col3'>
									<Typography>{item.lastLevelAttributeName}</Typography>
								</ListItem>
								<ListItem className='skill-col4'>
									<Typography>{item.isInDemand ? t('Yes') : t('No')}</Typography>
								</ListItem>
								<ListItem className='skill-col5'>
									<Typography>{item.status}</Typography>
								</ListItem>
								<ListItem className='skill-col6'>
									<Typography>{item.numberOfRolesMapped}</Typography>
								</ListItem>
							</List>
						</Box>
					))}
				</Box>
			) : (
				<NoRecord
					noRecordMessage={t('noSkillFrameworkCreatedYet')}
					subHead={t('clickPlusIconToAddFramework')}
					noDataImgWidth={'516'}
					noImg={NoDataImg}
					{...props}
				/>
			)}
		</>
	);
};
